const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/checklist-library.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/client/checklist-library")({
  beforeLoad: args => requirePermission(Permissions.ChecklistLibrary.Manage, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * SystemAdmin: per-client view of the checklist library.
 *
 * Every catalog item is a row showing whether the tenant already holds a
 * copy (`importedCopies` on the grants response — provenance
 * `Checklist.SourceSystemChecklistId`) and an "Import to client" button that
 * copies the latest published version in (always a NEW checklist; the
 * dialog requires consent for a duplicate).
 *
 * The "Self-serve access" toggle adds / revokes an explicit grant (`POST` /
 * `DELETE /clients/{id}/checklist-library/grants`). A tenant can access an
 * item when it is published and either tagged with the tenant's industry or
 * granted. That access only matters for client self-serve library browsing
 * (Phase 3, not built yet): every current import path — this page, the
 * starter pack, JSON import — bypasses it. The page says so explicitly.
 */